import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { WebComponentsContext } from '@whoop/web-components';
import analytics from '@whoop/web-analytics';
import Expired from 'pages/expired';
import Consent from 'pages/consent';
import Login from 'pages/login';
import config from 'config';
import initializeLocalization from './localization';
import '@whoop/web-components/dist/index.css';
import './index.css';

initializeLocalization();

analytics.initialize({
  datadog: {
    applicationId: config.datadogApplicationId,
    clientToken: config.datadogClientToken,
    service: config.datadogService,
    env: config.env,
  },
});

function App() {
  const { i18n } = useTranslation();

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <WebComponentsContext.Provider value={{ language: i18n.language }}>
      <BrowserRouter>
        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="expired" element={<Expired />} />
          <Route path="consent" element={<Consent />} />
        </Routes>
      </BrowserRouter>
    </WebComponentsContext.Provider>
  );
}

export default App;
